export default __webpack_public_path__ + "static/media/rocket_anim_149.6b098a53.png";